import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import { PaymentSettings } from 'src/app/settings/models/payment-settings.model';
import { AppSettings } from 'src/app/shared/constants/app-settings.constants';
import { ClientSettingsService } from '../services/auth/client-settings.service';
import { SettingsManagementService } from '../services/http/agency-mgmt/settings-management.service';

@Injectable({
  providedIn: 'root',
})
export class CreditCardGuard {
  constructor(
    private clientSettingsService: ClientSettingsService,
    private settingsManagementService: SettingsManagementService,
    private router: Router
  ) {}

  paymentSettings: PaymentSettings;
  isCreditCardActivatedOrg: boolean = true;

  canActivate(state: RouterStateSnapshot) {
    this.isCreditCardActivatedOrg = this.clientSettingsService.get('isCreditCardActivatedOrg', false);
    this.settingsManagementService.getPaymentSettings().subscribe(
        {
          next: (response: PaymentSettings) => {
            this.paymentSettings = response;
            this.isCreditCardActivatedOrg = this.paymentSettings.isCreditCardActivatedOrg;
            this.clientSettingsService.set(
              AppSettings.IsCreditCardActivatedOrg,
              this.paymentSettings.isCreditCardActivatedOrg,
              false
            );
            if(!this.isCreditCardActivatedOrg){
              this.router.navigate(['/settings'], {
                queryParams: { returnUrl: state.url },
                });
            }
        },
        error: error => {
            return true;
        }
    });

    if(this.isCreditCardActivatedOrg === false){
      this.router.navigate(['/settings'], {
          queryParams: { returnUrl: state.url },
          });
      return false;
    } else {
        return true;
    }
  }

}
